import main from './main';
import timeline from './timeline';
import media from './media';
import trash from './trash';
import operator from './operator';
import operatorWorks from './operatorWorks';
import userPrompt from './userPrompt';
import issue from './issue';
import company from './company';
import position from './position';
import device from './device';
import master from './master';
import room from './room';
import activation from './activation';
import remote from './remote';
import blackboard from './blackboard';
import group from './group';
import favorite from './favorite';
import actionLog from './actionLog';
import report from './report';
import deviceAuth from './deviceAuth';

const reducers = {
  main,
  timeline,
  media,
  trash,
  operator,
  operatorWorks,
  userPrompt,
  issue,
  company,
  position,
  device,
  master,
  room,
  activation,
  remote,
  blackboard,
  group,
  favorite,
  actionLog,
  report,
  deviceAuth,
};

export default reducers;
